import {Directive, HostBinding, Input} from "@angular/core";

@Directive()
export abstract class FUIAbstractDomComponent {
    @HostBinding("class.disabled") @Input() public disabled: boolean;
    @HostBinding("class.readonly") @Input() public readonly: boolean;
    @HostBinding("class.focussed") @Input() public focussed: boolean;
    @HostBinding("class.hovered") @Input() public hovered: boolean;
    @HostBinding("class.valued") @Input() public valued: boolean;
}
